<script>
export default {
  created () {
    $('.btn-refresh').tooltip()
  },

  methods: {
    refreshRdp: function () {
      $('.btn-refresh').tooltip('hide')
      $('#guac').attr('src', '/connect/viewer')
    },
  }
}
</script>

<template>
  <a class="btn-refresh"
    data-toggle="tooltip"
    data-container=".rdp"
    data-placement="left"
    title="Refresh RDP"
    href="#"
    @click.prevent="refreshRdp"
  >
    <i class="fa fa-refresh"></i>
  </a>
</template>
